(function () {
  var SELECTOR = 'a[href*="wa.me"], a[href*="whatsapp.com"], a[href*="api.whatsapp"]';

  function bind(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(function (link) {
      if (link.dataset.mnWaBound === '1') return;
      link.dataset.mnWaBound = '1';
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
    });
  }

  function init() {
    bind(document);
    window.setTimeout(function () {
      bind(document);
    }, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (typeof MutationObserver !== 'undefined') {
    var timer;
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var nodes = mutations[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var node = nodes[j];
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches(SELECTOR)) bind(node.parentNode || document);
          else if (node.querySelectorAll) bind(node);
        }
      }
      clearTimeout(timer);
      timer = window.setTimeout(function () {
        bind(document);
      }, 250);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
